import { FC } from 'react';

import {
  HelpComponentWrapper,
  HelpText,
  HelpChapterProps,
  WinnersList,
  useConfigSlice,
  useSettingsSlice,
  useTranslation,
  useIsLargerThanWide,
} from '@pp/core';

import { Bets } from '../../../config/bets';
import { BetSpot } from '../../gameGrid/betSpot';
import { WinResult } from '../../winResult';

export const HelpChapterGameResult: FC<HelpChapterProps> = ({ content, isStorybook }) => {
  const isWide = useIsLargerThanWide();
  const tableNameKey = useConfigSlice.tableConfig()?.tableName ?? '';
  const locale = useSettingsSlice.currentLanguage();
  const { translations } = useTranslation();
  const tableName = translations[tableNameKey] || tableNameKey;

  const winners = [
    {
      userId: '',
      screenName: 'Poker_face',
      currency: 'EUR',
      win: 700000,
      megawin: false,
    },
    {
      userId: '',
      screenName: 'Tardisblue',
      currency: 'EUR',
      win: 600950,
      megawin: false,
    },
    {
      userId: '',
      screenName: 'MrLuckWong',
      currency: 'EUR',
      win: 580000,
      megawin: false,
    },
    {
      userId: '',
      screenName: 'Rouletter2',
      currency: 'EUR',
      win: 570000,
      megawin: false,
    },
    {
      userId: '',
      screenName: 'chezter1987',
      currency: 'EUR',
      win: 534000,
      megawin: false,
    },
    {
      userId: '',
      screenName: 'Pernyamaa',
      currency: 'EUR',
      win: 521000,
      megawin: false,
    },
    {
      userId: '',
      screenName: 'Kazanbas12',
      currency: 'EUR',
      win: 520000,
      megawin: false,
    },
    {
      userId: 'ppc16826wsdds',
      screenName: 'LuckyGeoff',
      currency: 'EUR',
      win: 500000,
      megawin: false,
    },
    {
      userId: '',
      screenName: 'Geralt',
      currency: 'EUR',
      win: 42,
      megawin: false,
    },
    {
      userId: '',
      screenName: 'MegaSheer',
      currency: 'EUR',
      win: 21,
      megawin: false,
    },
    {
      userId: '',
      screenName: 'Jeeves75',
      currency: 'EUR',
      win: 18,
      megawin: false,
    },
    {
      userId: '',
      screenName: 'Trevor9',
      currency: 'EUR',
      win: 14,
      megawin: false,
    },
    {
      userId: '',
      screenName: 'Bacc_rat',
      currency: 'EUR',
      win: 12,
      megawin: false,
    },
    {
      userId: '',
      screenName: 'SSC_Miami',
      currency: 'EUR',
      win: 8,
      megawin: false,
    },
  ];

  const total = winners.reduce((totalWin, winner) => {
    return totalWin + winner.win;
  }, 0);

  if (!content) return null;

  return (
    <div>
      <p>
        <HelpText dynamicValues={{ TABLE_NAME: `${tableName}` }}>{String(content.winningSymbols)}</HelpText>
      </p>
      <HelpComponentWrapper
        style={{
          width: 'var(--game-help-wrapper-width)',
          margin: '0px auto',
          textAlign: 'center',
          marginTop: 'var(--game-help-betspot-spacing)',
          transform: 'scale(var(--game-help-betspot-scale))',
          maxWidth: isStorybook ? '122px' : 'unset',
        }}
      >
        <div
          style={{
            padding: '2px',
            boxSizing: 'border-box',
            borderRadius: '12px',
            width: '100%',
            height: '100%',
            position: 'relative',
            right: '7%',
          }}
        >
          <BetSpot
            value={20}
            megaMultiplier={100}
            onBet={(): null => null}
            disabled={false}
            bet={Bets.Five}
            multiplier={2}
            winning={true}
            isMegaWin={true}
          />
        </div>
      </HelpComponentWrapper>
      <p>
        <HelpText>{String(content.winMessage)}</HelpText>
      </p>

      <HelpComponentWrapper
        style={{
          transform: ['hy', 'hu'].includes(locale) ? 'scale(0.6)' : 'scale(0.8)',
          display: 'grid',
        }}
      >
        <WinResult winAmount="€5.00" winType={'YOU_WIN'} />
      </HelpComponentWrapper>

      <HelpComponentWrapper
        style={{
          display: 'grid',
          transform: ['hy', 'hu'].includes(locale) ? 'scale(0.6)' : 'scale(0.8)',
        }}
      >
        <WinResult winAmount="€101.00" winType={'MEGA_WIN'} />
      </HelpComponentWrapper>

      <p>
        <HelpText>{String(content.winnerList)}</HelpText>
      </p>
      <HelpComponentWrapper
        style={{
          position: 'relative',
          margin: isWide ? 0 : 'var(--core-spacing-intermidiate) 0',
          display: isWide ? 'block' : 'flex',
        }}
      >
        <WinnersList
          winners={winners}
          winnersTotal={{ totalEur: total.toString(), winnersCount: winners.length.toString() }}
          currentUser={'ppc16826wsdds'}
          currency={'EUR'}
          locale={'en'}
          isPaused={true}
          isPassive={true}
        />
      </HelpComponentWrapper>
    </div>
  );
};
